import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  NothingSerializer3oixyyf77l4xt as NothingSerializer,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  SetSerializert3lb0yy9iftr as SetSerializer,
  MapSerializer11kmegt3g5c1g as MapSerializer,
  MapEntrySerializer3oe1sx5ozvw2u as MapEntrySerializer,
  PairSerializer1d18kmsqyj4f as PairSerializer,
  TripleSerializer39fneesmgp1wy as TripleSerializer,
  serializer1cdzkc3mnhoc4 as serializer,
  serializer3u3hsxnenk49x as serializer_0,
  serializer1r0h5yakm679b as serializer_1,
  serializer36584sjyg5661 as serializer_2,
  serializer1tw0a8bv7lkga as serializer_3,
  serializer1q7c5q67ysppr as serializer_4,
  serializer1hu9wv9at41ww as serializer_5,
  serializer3ikrxnm8b29d6 as serializer_6,
  serializerodflzzf6s3fp as serializer_7,
  serializer2lw83vwvpnyms as serializer_8,
  serializer3x9uckd1deom as serializer_9,
  serializer1wpgysz06u9ol as serializer_10,
  serializer345btyh1f2y1j as serializer_11,
  serializer1x79l67jvwntn as serializer_12,
  serializer37oyvz7rc4nep as serializer_13,
  serializer1j5a5justjsv5 as serializer_14,
  serializer1x80idigipeic as serializer_15,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { toList383f556t1dixk as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  contextual3hpp1gupsu4al as contextual,
  SerializersModuleCollector3dddz14wd7brg as SerializersModuleCollector,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleCollector.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  ClosedRangeSerializer1wdhu7jrbhw7o as ClosedRangeSerializer,
  DurationMsSerializer_getInstancecr673uo7gg5q as DurationMsSerializer_getInstance,
} from './Serializers.mjs';
import { Companion_getInstance2slzm1chafr5y as Companion_getInstance } from './CollectionChanges.mjs';
import { Companion_getInstancelkcs3vv5v0ys as Companion_getInstance_0 } from './CollectionUpdates.mjs';
import {
  Companion_instance170wh3hu8c61 as Companion_instance,
  Companion_instance2q8fv6rz9kty0 as Companion_instance_0,
  Companion_instancen43ljy30xhzi as Companion_instance_1,
  Companion_instance1rxmb5wyn6fsk as Companion_instance_2,
  Companion_instance1x5ptgth8zhxi as Companion_instance_3,
  Companion_instance3sjn2yjp2itr2 as Companion_instance_4,
  Companion_instance27qzp1hsrgk5v as Companion_instance_5,
  Companion_instance2ofs92i7mv51v as Companion_instance_6,
  Companion_instanceph7m2qn20p7q as Companion_instance_7,
  Companion_instancetlzvdhi57ju2 as Companion_instance_8,
  Companion_instance2z7r598ruzfgp as Companion_instance_9,
  Companion_instanceh57sw6cyw523 as Companion_instance_10,
  Companion_getInstance2w0ry8ukons4w as Companion_getInstance_1,
  Companion_getInstance2n1o7xahtwe38 as Companion_getInstance_2,
  Companion_instance1rv4h7xeh426o as Companion_instance_11,
  Companion_instance9b6acjoxpq0c as Companion_instance_12,
  Companion_instance3s54ycq8t72xu as Companion_instance_13,
  Companion_instance1xqhrale4ydxi as Companion_instance_14,
  Companion_instance2igigxyt265zn as Companion_instance_15,
  Companion_instanceheuor90dqw2p as Companion_instance_16,
  Companion_instancehonhf7q97gvq as Companion_instance_17,
  Companion_getInstance1r7wm1v3dq4i3 as Companion_getInstance_3,
  Companion_instance326hk1r71xax as Companion_instance_18,
  Never_getInstance3of1faxayn0qw as Never_getInstance,
  Always_getInstance177eud73uc475 as Always_getInstance,
  Companion_instance2auwgabo579v8 as Companion_instance_19,
  Companion_instance334xz54gwgpk7 as Companion_instance_20,
  Companion_instance28iz6ufuyency as Companion_instance_21,
  Companion_instancefyqtx24roelu as Companion_instance_22,
  Companion_instance15i08a3149tp6 as Companion_instance_23,
  Companion_instance2sjog5kofh6gw as Companion_instance_24,
  Companion_instance2j477vxcf0eam as Companion_instance_25,
} from './Condition.mjs';
import { Companion_getInstance2k7q2bnzfxhnl as Companion_getInstance_4 } from './EntryChange.mjs';
import {
  Companion_getInstance3oqgrjvfi17jk as Companion_getInstance_5,
  Companion_getInstance3ouvgkx7lgis5 as Companion_getInstance_6,
  Companion_getInstance1qfdwb51f0ue as Companion_getInstance_7,
} from './GroupCountQuery.mjs';
import { Companion_getInstance20kj6uotbl2x7 as Companion_getInstance_8 } from './ListChange.mjs';
import { Companion_getInstancefutwz1zk5x6k as Companion_getInstance_9 } from './Mask.mjs';
import { Companion_getInstancemcidlsfrtpdg as Companion_getInstance_10 } from './MassModification.mjs';
import { Companion_getInstance2v6degzrm2jsl as Companion_getInstance_11 } from './ModelPermissions.mjs';
import {
  Companion_instance7x85vjcu6250 as Companion_instance_26,
  Companion_instance16cifvdjsintt as Companion_instance_27,
  Companion_instance3bnzzufvyr983 as Companion_instance_28,
  Companion_instance3q5qrbb8dvim2 as Companion_instance_29,
  Companion_instance2xs5meuo4uk7b as Companion_instance_30,
  Companion_instance1iw39v478z3sa as Companion_instance_31,
  Companion_instance3okjoeswc063e as Companion_instance_32,
  Companion_instance3jp69gxf6v3e3 as Companion_instance_33,
  Companion_instanced9y0ghw4y3f4 as Companion_instance_34,
  Companion_instanceez0w06et8n0z as Companion_instance_35,
  Companion_instance288oh9kic3o9e as Companion_instance_36,
  Companion_instance1fe0vifomrwt0 as Companion_instance_37,
  Companion_instance2ca3a70e9t58s as Companion_instance_38,
  Companion_instancewuhi7j8dzj2n as Companion_instance_39,
  Companion_getInstance7fe8bbmq9v9z as Companion_getInstance_12,
  Companion_instancetqr20ikb6k9i as Companion_instance_40,
  Companion_instance1brivik930s8s as Companion_instance_41,
  Companion_instance1skqa9ankg6k1 as Companion_instance_42,
  Companion_instance2dt70m4k7qloa as Companion_instance_43,
  Companion_instance385iatw7zqcbc as Companion_instance_44,
  Companion_getInstance2sdnjo9tz10if as Companion_getInstance_13,
  Companion_instance2gc3grqkqb8ba as Companion_instance_45,
  Companion_instanceh5qpv80ys58j as Companion_instance_46,
  Nothing_getInstance1x7nejv3dwhdr as Nothing_getInstance,
  Companion_instance1oe56hdndwklm as Companion_instance_47,
} from './Modification.mjs';
import { Companion_getInstance3jmcdc9kv8nln as Companion_getInstance_14 } from './Query.mjs';
import { Companion_getInstance3d34otlkn11wr as Companion_getInstance_15 } from './QueryPartial.mjs';
import { Companion_instance3giyawr5ckwev as Companion_instance_48 } from './SortPart.mjs';
import {
  Companion_getInstancelevea1paw68a as Companion_getInstance_16,
  Companion_getInstance1mj22e08iawmm as Companion_getInstance_17,
} from './UpdateRestrictions.mjs';
import { Companion_instance1blhtv320q15h as Companion_instance_49 } from './DataClassPath.mjs';
import { Companion_instance8en83qldk4o3 as Companion_instance_50 } from './Partial.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import {
  BooleanCompanionObject_instance2tls5h1cufcrh as BooleanCompanionObject_instance,
  ByteCompanionObject_instance1r92wkzdy7g72 as ByteCompanionObject_instance,
  ShortCompanionObject_instance33mqksfmw0mrs as ShortCompanionObject_instance,
  IntCompanionObject_instance3g0jtywew2pgh as IntCompanionObject_instance,
  FloatCompanionObject_instanceokgc3apyetrg as FloatCompanionObject_instance,
  DoubleCompanionObject_instance43opzxl97v4p as DoubleCompanionObject_instance,
  StringCompanionObject_instance2dx16b5pp3v3z as StringCompanionObject_instance,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { Companion_getInstanceb1xi7131i8df as Companion_getInstance_18 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { Companion_getInstance1foc7f9q9rk1s as Companion_getInstance_19 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import { Companion_getInstance1crempiiqys0g as Companion_getInstance_20 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import { Companion_instancel8ig9z4updma as Companion_instance_51 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Primitives.mjs';
import { Companion_getInstance11ies3wlxhmd7 as Companion_getInstance_21 } from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { Companion_getInstance1genqokpkr3uz as Companion_getInstance_22 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1hwzc6m64v1op as serializer_16 } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { UByteArray2qu4d6gwssdf9 as UByteArray } from '../../../../../kotlin-kotlin-stdlib/kotlin/UByteArray.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { UShortArray11avpmknxdgvv as UShortArray } from '../../../../../kotlin-kotlin-stdlib/kotlin/UShortArray.mjs';
import { UIntArrayrp6cv44n5v4y as UIntArray } from '../../../../../kotlin-kotlin-stdlib/kotlin/UIntArray.mjs';
import { ULongArray3nd0d80mdwjj8 as ULongArray } from '../../../../../kotlin-kotlin-stdlib/kotlin/ULongArray.mjs';
import { Companion_getInstance2jahap30xtp3t as Companion_getInstance_23 } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { Companion_getInstance13ujfby7pfhe7 as Companion_getInstance_24 } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import { Companion_getInstance138pnyl3l6agm as Companion_getInstance_25 } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Instant.mjs';
import { Companion_getInstance3h03aipe2gus4 as Companion_getInstance_26 } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { Companion_getInstance3qlladteis94 as Companion_getInstance_27 } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalTime.mjs';
import { Companion_getInstance29buwn7hkq75x as Companion_getInstance_28 } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDateTime.mjs';
import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance_29 } from '../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import {
  OffsetDateTimeIso8601Serializer_getInstance1wmrj50dhqyob as OffsetDateTimeIso8601Serializer_getInstance,
  ZonedDateTimeIso8601Serializer_getInstance11y1vnw7kq0m4 as ZonedDateTimeIso8601Serializer_getInstance,
  Companion_instance1awt21sjla5gi as Companion_instance_52,
  Companion_instance45cl7eqbjvkq as Companion_instance_53,
} from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/ZonedDateTime.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { Companion_instance3paxl0a3a7ty8 as Companion_instance_54 } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/GeoCoordinate.mjs';
import {
  Companion_instancehk7vx2dhtw7x as Companion_instance_55,
  Companion_instancesxz2s5pmyc3v as Companion_instance_56,
  Companion_instance21aecnguozao5 as Companion_instance_57,
  Companion_getInstance3d9mpftfjw6px as Companion_getInstance_30,
  Companion_instance2u6g2z0babd2s as Companion_instance_58,
} from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import {
  Companion_instance2ik3kqchmtmbs as Companion_instance_59,
  Companion_instance3a9vd05w7sq9 as Companion_instance_60,
  Companion_instance1c4by1hwszuh3 as Companion_instance_61,
  Companion_instance2elpx49h5lx9i as Companion_instance_62,
  Companion_instance3h4e1xnva2ie7 as Companion_instance_63,
  Companion_instance2g4pvq9z8og54 as Companion_instance_64,
  Companion_instance2dv3afb3e9be1 as Companion_instance_65,
  Companion_instance1wq80gp5u5pdh as Companion_instance_66,
  Companion_instance2drvy6prp15q0 as Companion_instance_67,
  Companion_instance1y3kls3ft58mt as Companion_instance_68,
  Companion_instance2n64nzts3l969 as Companion_instance_69,
  Companion_instance19yah1y07knv1 as Companion_instance_70,
  Companion_instance1psl1xhmbls3d as Companion_instance_71,
} from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/usefulTypes.mjs';
import { Companion_instance1c40ds0jrup2e as Companion_instance_72 } from '../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { replace3le3ie7l9k8aq as replace } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { Companion_getInstance3e2h11tnt9mtt as Companion_getInstance_31 } from './Aggregate.mjs';
import {
  Companion_getInstance3vgjjqthbx88p as Companion_getInstance_32,
  Companion_instance1euxei6nfs2w0 as Companion_instance_73,
  Companion_getInstance184rpyho39fqw as Companion_getInstance_33,
  Companion_getInstance6160e1yv7jen as Companion_getInstance_34,
  Companion_getInstance3a8144f02tjl2 as Companion_getInstance_35,
  Companion_getInstance1sv7pt72vq00c as Companion_getInstance_36,
  Companion_getInstancevnkc3zf23j20 as Companion_getInstance_37,
  Companion_getInstancerpzvysyka08o as Companion_getInstance_38,
  Companion_getInstance27tg9jz4geu2v as Companion_getInstance_39,
  Companion_getInstance2gbof873kqjb4 as Companion_getInstance_40,
  Companion_getInstance3qgqr058re7xq as Companion_getInstance_41,
  NullValue_getInstance2jbsw90ml8iwr as NullValue_getInstance,
  Companion_instance33wqjxm3zfzx3 as Companion_instance_74,
  Companion_instanced7f59egpynym as Companion_instance_75,
  Companion_instance2xygx2n0705wi as Companion_instance_76,
  Companion_instance22rhl5jjczjv3 as Companion_instance_77,
  Companion_instance1em9315zvkjzr as Companion_instance_78,
  Companion_instancetgfq5f4oczrl as Companion_instance_79,
  Companion_instance1lwpxmbnz6iur as Companion_instance_80,
  Companion_instance2v9aitb9yta1m as Companion_instance_81,
  Companion_instance3olmodtpz49ra as Companion_instance_82,
  Companion_instance255g87ali8q4h as Companion_instance_83,
  Companion_getInstance1ros06qto3hv2 as Companion_getInstance_42,
} from './VirtualType.mjs';
import { AbstractDecoder35guh02ubh2hm as AbstractDecoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractDecoder.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var GenericPlaceholderExceptionClass;
function GenericPlaceholderException() {
  if (GenericPlaceholderExceptionClass === VOID) {
    class $ extends Exception() {}
    initMetadataForClass($, 'GenericPlaceholderException');
    GenericPlaceholderExceptionClass = $;
  }
  return GenericPlaceholderExceptionClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_84 = this;
        this.permitCustomContextual_1 = false;
        this.master_1 = new (SerializationRegistry())(EmptySerializersModule());
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_84;
function Companion_getInstance_43() {
  if (Companion_instance_84 === VOID)
    new (Companion())();
  return Companion_instance_84;
}
var GenericPlaceholderSerializerClass;
function GenericPlaceholderSerializer() {
  if (GenericPlaceholderSerializerClass === VOID) {
    class $ {}
    initMetadataForClass($, 'GenericPlaceholderSerializer', VOID, VOID, [KSerializer()]);
    GenericPlaceholderSerializerClass = $;
  }
  return GenericPlaceholderSerializerClass;
}
var SerializationRegistry$1Class;
function SerializationRegistry$1() {
  if (SerializationRegistry$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.this$0__1 = this$0;
      }
      contextual_cy8rhx_k$(kClass, provider) {
        var tmp = 0;
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_0 = Array(10);
        while (tmp < 10) {
          tmp_0[tmp] = NothingSerializer();
          tmp = tmp + 1 | 0;
        }
        var sample = ContextualSerializer().new_kotlinx_serialization_ContextualSerializer_niymzz_k$(kClass, null, tmp_0);
        println('Contextual serializer inserted for ' + sample.descriptor_1.get_serialName_u2rqhk_k$());
        var tmp0 = this.this$0__1.factory_1;
        var tmp2 = sample.descriptor_1.get_serialName_u2rqhk_k$();
        // Inline function 'kotlin.collections.set' call
        var value = (it) => provider(toList(it));
        tmp0.put_4fpzoq_k$(tmp2, value);
      }
      polymorphic_q1pzlt_k$(baseClass, actualClass, actualSerializer) {
      }
      polymorphicDefaultDeserializer_1at2c4_k$(baseClass, defaultDeserializerProvider) {
      }
      polymorphicDefaultSerializer_svn9pe_k$(baseClass, defaultSerializerProvider) {
      }
    }
    protoOf($).contextual_phl8co_k$ = contextual;
    initMetadataForClass($, VOID, VOID, VOID, [SerializersModuleCollector()]);
    SerializationRegistry$1Class = $;
  }
  return SerializationRegistry$1Class;
}
function SerializationRegistry$lambda(it) {
  return ListSerializer(it[0]);
}
function SerializationRegistry$lambda_0(it) {
  return SetSerializer(it[0]);
}
function SerializationRegistry$lambda_1(it) {
  return MapSerializer(it[0], it[1]);
}
function SerializationRegistry$lambda_2(it) {
  return SetSerializer(it[0]);
}
function SerializationRegistry$lambda_3(it) {
  return MapSerializer(it[0], it[1]);
}
function SerializationRegistry$lambda_4(it) {
  return MapEntrySerializer(it[0], it[1]);
}
function SerializationRegistry$lambda_5(it) {
  return PairSerializer(it[0], it[1]);
}
function SerializationRegistry$lambda_6(it) {
  return TripleSerializer(it[0], it[1], it[2]);
}
function SerializationRegistry$lambda_7(it) {
  return new (ClosedRangeSerializer())(it[0]);
}
function SerializationRegistry$lambda_8(it) {
  return Companion_getInstance().serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_9(it) {
  return Companion_getInstance_0().serializer_cre5l3_k$(it[0], it[1]);
}
function SerializationRegistry$lambda_10(it) {
  return Companion_instance.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_11(it) {
  return Companion_instance_0.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_12(it) {
  return Companion_instance_1.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_13(it) {
  return Companion_instance_2.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_14(it) {
  return Companion_instance_3.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_15(it) {
  return Companion_instance_4.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_16(it) {
  return Companion_instance_5.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_17(it) {
  return Companion_instance_6.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_18(it) {
  return Companion_instance_7.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_19(it) {
  return Companion_instance_8.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_20(it) {
  return Companion_instance_9.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_21(it) {
  return Companion_instance_10.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_22(it) {
  return Companion_getInstance_1().serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_23(it) {
  return Companion_getInstance_2().serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_24(it) {
  return Companion_instance_11.serializer_szze8_k$(it[0]);
}
function SerializationRegistry$lambda_25(it) {
  return Companion_instance_12.serializer_szze8_k$(it[0]);
}
function SerializationRegistry$lambda_26(it) {
  return Companion_instance_13.serializer_szze8_k$(it[0]);
}
function SerializationRegistry$lambda_27(it) {
  return Companion_instance_14.serializer_szze8_k$(it[0]);
}
function SerializationRegistry$lambda_28(it) {
  return Companion_instance_15.serializer_szze8_k$(it[0]);
}
function SerializationRegistry$lambda_29(it) {
  return Companion_instance_16.serializer_szze8_k$(it[0]);
}
function SerializationRegistry$lambda_30(it) {
  return Companion_instance_17.serializer_r07i7m_k$(it[0]);
}
function SerializationRegistry$lambda_31(it) {
  return Companion_getInstance_3().serializer_r07i7m_k$(it[0]);
}
function SerializationRegistry$lambda_32(it) {
  return Companion_instance_18.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_33(it) {
  return Companion_getInstance_4().serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_34(it) {
  return Companion_getInstance_5().serializer_nrleg8_k$(it[0]);
}
function SerializationRegistry$lambda_35(it) {
  return Companion_getInstance_6().serializer_nrleg8_k$(it[0]);
}
function SerializationRegistry$lambda_36(it) {
  return Companion_getInstance_7().serializer_nrleg8_k$(it[0]);
}
function SerializationRegistry$lambda_37(it) {
  return Companion_getInstance_8().serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_38(it) {
  return Companion_getInstance_9().serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_39(it) {
  return Companion_getInstance_10().serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_40(it) {
  return Companion_getInstance_11().serializer_nrleg8_k$(it[0]);
}
function SerializationRegistry$lambda_41(it) {
  return Companion_instance_26.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_42(it) {
  return Companion_instance_27.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_43(it) {
  return Companion_instance_28.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_44(it) {
  return Companion_instance_29.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_45(it) {
  return Companion_instance_30.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_46(it) {
  return Companion_instance_31.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_47(it) {
  return Companion_instance_32.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_48(it) {
  return Companion_instance_33.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_49(it) {
  return Companion_instance_34.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_50(it) {
  return Companion_instance_35.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_51(it) {
  return Companion_instance_36.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_52(it) {
  return Companion_instance_37.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_53(it) {
  return Companion_instance_38.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_54(it) {
  return Companion_instance_39.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_55(it) {
  return Companion_getInstance_12().serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_56(it) {
  return Companion_instance_40.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_57(it) {
  return Companion_instance_41.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_58(it) {
  return Companion_instance_42.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_59(it) {
  return Companion_instance_43.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_60(it) {
  return Companion_instance_44.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_61(it) {
  return Companion_getInstance_13().serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_62(it) {
  return Companion_instance_45.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_63(it) {
  return Companion_instance_46.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_64(it) {
  return Companion_getInstance_14().serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_65(it) {
  return Companion_getInstance_15().serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_66(it) {
  return Companion_instance_48.serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_67(it) {
  return Companion_getInstance_16().serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_68(it) {
  return Companion_getInstance_17().serializer_qelnde_k$(it[0]);
}
function SerializationRegistry$lambda_69(it) {
  return Companion_instance_49.serializer_hd7dek_k$(it[0]);
}
function SerializationRegistry$lambda_70(it) {
  return Companion_instance_50.serializer_qelnde_k$(it[0]);
}
var SerializationRegistryClass;
function SerializationRegistry() {
  if (SerializationRegistryClass === VOID) {
    class $ {
      constructor(module_0) {
        Companion_getInstance_43();
        this.module_1 = module_0;
        this.direct_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
        this.factory_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
        this.internalVirtualTypes_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
        this.module_1.dumpTo_vt5sm4_k$(new (SerializationRegistry$1())(this));
        this.register$default_82hvd6_k$(serializer(Unit_instance));
        this.register$default_82hvd6_k$(serializer_0(BooleanCompanionObject_instance));
        this.register$default_82hvd6_k$(serializer_1(ByteCompanionObject_instance));
        this.register$default_82hvd6_k$(serializer_2(Companion_getInstance_18()));
        this.register$default_82hvd6_k$(serializer_3(ShortCompanionObject_instance));
        this.register$default_82hvd6_k$(serializer_4(Companion_getInstance_19()));
        this.register$default_82hvd6_k$(serializer_5(IntCompanionObject_instance));
        this.register$default_82hvd6_k$(serializer_6(Companion_getInstance_20()));
        this.register$default_82hvd6_k$(serializer_7(Companion_instance_51));
        this.register$default_82hvd6_k$(serializer_8(Companion_getInstance_21()));
        this.register$default_82hvd6_k$(serializer_9(FloatCompanionObject_instance));
        this.register$default_82hvd6_k$(serializer_10(DoubleCompanionObject_instance));
        this.register$default_82hvd6_k$(serializer_11(Companion_getInstance_22()));
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_0 = serializer_16(createKType(PrimitiveClasses_getInstance().get_booleanArrayClass_lnbwea_k$(), arrayOf([]), false));
        var tmp$ret$0 = isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE();
        this.register$default_82hvd6_k$(tmp$ret$0);
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_1 = serializer_16(createKType(PrimitiveClasses_getInstance().get_byteArrayClass_57my8g_k$(), arrayOf([]), false));
        var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
        this.register$default_82hvd6_k$(tmp$ret$2);
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_16(createKType(getKClass(UByteArray()), arrayOf([]), false));
        var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        this.register$default_82hvd6_k$(tmp$ret$4);
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_3 = serializer_16(createKType(PrimitiveClasses_getInstance().get_shortArrayClass_c1p7wy_k$(), arrayOf([]), false));
        var tmp$ret$6 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
        this.register$default_82hvd6_k$(tmp$ret$6);
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_4 = serializer_16(createKType(getKClass(UShortArray()), arrayOf([]), false));
        var tmp$ret$8 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
        this.register$default_82hvd6_k$(tmp$ret$8);
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_5 = serializer_16(createKType(PrimitiveClasses_getInstance().get_intArrayClass_h44pbv_k$(), arrayOf([]), false));
        var tmp$ret$10 = isInterface(this_5, KSerializer()) ? this_5 : THROW_CCE();
        this.register$default_82hvd6_k$(tmp$ret$10);
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_6 = serializer_16(createKType(getKClass(UIntArray()), arrayOf([]), false));
        var tmp$ret$12 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
        this.register$default_82hvd6_k$(tmp$ret$12);
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_7 = serializer_16(createKType(PrimitiveClasses_getInstance().get_longArrayClass_v379a4_k$(), arrayOf([]), false));
        var tmp$ret$14 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
        this.register$default_82hvd6_k$(tmp$ret$14);
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_8 = serializer_16(createKType(getKClass(ULongArray()), arrayOf([]), false));
        var tmp$ret$16 = isInterface(this_8, KSerializer()) ? this_8 : THROW_CCE();
        this.register$default_82hvd6_k$(tmp$ret$16);
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_9 = serializer_16(createKType(PrimitiveClasses_getInstance().get_floatArrayClass_qngmha_k$(), arrayOf([]), false));
        var tmp$ret$18 = isInterface(this_9, KSerializer()) ? this_9 : THROW_CCE();
        this.register$default_82hvd6_k$(tmp$ret$18);
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_10 = serializer_16(createKType(PrimitiveClasses_getInstance().get_doubleArrayClass_84hee1_k$(), arrayOf([]), false));
        var tmp$ret$20 = isInterface(this_10, KSerializer()) ? this_10 : THROW_CCE();
        this.register$default_82hvd6_k$(tmp$ret$20);
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_11 = serializer_16(createKType(PrimitiveClasses_getInstance().get_charArrayClass_7lhfoe_k$(), arrayOf([]), false));
        var tmp$ret$22 = isInterface(this_11, KSerializer()) ? this_11 : THROW_CCE();
        this.register$default_82hvd6_k$(tmp$ret$22);
        this.register$default_82hvd6_k$(serializer_12(StringCompanionObject_instance));
        this.register$default_82hvd6_k$(serializer_13(Companion_getInstance_23()));
        this.register$default_82hvd6_k$(Companion_getInstance_24().serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(serializer_14(Companion_getInstance_25()));
        this.register$default_82hvd6_k$(Companion_getInstance_26().serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_getInstance_27().serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_getInstance_28().serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(DurationMsSerializer_getInstance());
        this.register$default_82hvd6_k$(serializer_15(Companion_getInstance_29()));
        this.register$default_82hvd6_k$(OffsetDateTimeIso8601Serializer_getInstance());
        this.register$default_82hvd6_k$(ZonedDateTimeIso8601Serializer_getInstance());
        var tmp = ListSerializer(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp, SerializationRegistry$lambda);
        var tmp_0 = SetSerializer(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_0, SerializationRegistry$lambda_0);
        var tmp_1 = MapSerializer(NothingSerializer(), NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_1, SerializationRegistry$lambda_1);
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_12 = serializer_16(createKType(getKClass(HashSet()), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().get_intClass_mw4y9a_k$(), arrayOf([]), false))]), false));
        var tmp_2 = (isInterface(this_12, KSerializer()) ? this_12 : THROW_CCE()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_2, SerializationRegistry$lambda_2);
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_13 = serializer_16(createKType(getKClass(HashMap()), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().get_intClass_mw4y9a_k$(), arrayOf([]), false))]), false));
        var tmp_3 = (isInterface(this_13, KSerializer()) ? this_13 : THROW_CCE()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_3, SerializationRegistry$lambda_3);
        var tmp_4 = MapEntrySerializer(NothingSerializer(), NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_4, SerializationRegistry$lambda_4);
        var tmp_5 = PairSerializer(NothingSerializer(), NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_5, SerializationRegistry$lambda_5);
        var tmp_6 = TripleSerializer(NothingSerializer(), NothingSerializer(), NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_6, SerializationRegistry$lambda_6);
        var tmp_7 = (new (ClosedRangeSerializer())(NothingSerializer())).descriptor_1.get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_7, SerializationRegistry$lambda_7);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = listOf([Companion_instance_54.serializer_9w0wvi_k$(), Companion_instance_55.serializer_9w0wvi_k$(), Companion_instance_56.serializer_9w0wvi_k$(), Companion_instance_57.serializer_9w0wvi_k$(), Companion_getInstance_30().serializer_9w0wvi_k$(), Companion_instance_58.serializer_9w0wvi_k$(), Companion_instance_52.serializer_9w0wvi_k$(), Companion_instance_53.serializer_9w0wvi_k$(), Companion_instance_59.serializer_9w0wvi_k$(), Companion_instance_60.serializer_9w0wvi_k$(), Companion_instance_61.serializer_9w0wvi_k$(), Companion_instance_62.serializer_9w0wvi_k$(), Companion_instance_63.serializer_9w0wvi_k$(), Companion_instance_64.serializer_9w0wvi_k$(), Companion_instance_65.serializer_9w0wvi_k$(), Companion_instance_66.serializer_9w0wvi_k$(), Companion_instance_67.serializer_9w0wvi_k$(), Companion_instance_68.serializer_9w0wvi_k$(), Companion_instance_69.serializer_9w0wvi_k$(), Companion_instance_70.serializer_9w0wvi_k$(), Companion_instance_71.serializer_9w0wvi_k$(), Companion_instance_72.serializer_9w0wvi_k$()]).iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          this.register$default_82hvd6_k$(element);
          this.register_l6joql_k$(element, replace(element.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'com.lightningkite.services.data', 'com.lightningkite'));
        }
        this.register$default_82hvd6_k$(Companion_getInstance_31().serializer_9w0wvi_k$());
        var tmp_8 = Companion_getInstance().serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_8, SerializationRegistry$lambda_8);
        var tmp_9 = Companion_getInstance_0().serializer_cre5l3_k$(NothingSerializer(), NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_9, SerializationRegistry$lambda_9);
        var tmp_10 = Companion_instance.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_10, SerializationRegistry$lambda_10);
        this.register$default_82hvd6_k$(Never_getInstance().serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Always_getInstance().serializer_9w0wvi_k$());
        var tmp_11 = Companion_instance_0.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_11, SerializationRegistry$lambda_11);
        var tmp_12 = Companion_instance_1.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_12, SerializationRegistry$lambda_12);
        var tmp_13 = Companion_instance_2.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_13, SerializationRegistry$lambda_13);
        var tmp_14 = Companion_instance_3.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_14, SerializationRegistry$lambda_14);
        var tmp_15 = Companion_instance_4.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_15, SerializationRegistry$lambda_15);
        var tmp_16 = Companion_instance_5.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_16, SerializationRegistry$lambda_16);
        var tmp_17 = Companion_instance_6.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_17, SerializationRegistry$lambda_17);
        var tmp_18 = Companion_instance_7.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_18, SerializationRegistry$lambda_18);
        var tmp_19 = Companion_instance_8.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_19, SerializationRegistry$lambda_19);
        var tmp_20 = Companion_instance_9.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_20, SerializationRegistry$lambda_20);
        var tmp_21 = Companion_instance_10.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_21, SerializationRegistry$lambda_21);
        this.register$default_82hvd6_k$(Companion_instance_19.serializer_9w0wvi_k$());
        var tmp_22 = Companion_getInstance_1().serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_22, SerializationRegistry$lambda_22);
        this.register$default_82hvd6_k$(Companion_instance_20.serializer_9w0wvi_k$());
        var tmp_23 = Companion_getInstance_2().serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_23, SerializationRegistry$lambda_23);
        this.register$default_82hvd6_k$(Companion_instance_21.serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_instance_22.serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_instance_23.serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_instance_24.serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_instance_25.serializer_9w0wvi_k$());
        var tmp_24 = Companion_instance_11.serializer_szze8_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_24, SerializationRegistry$lambda_24);
        var tmp_25 = Companion_instance_12.serializer_szze8_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_25, SerializationRegistry$lambda_25);
        var tmp_26 = Companion_instance_13.serializer_szze8_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_26, SerializationRegistry$lambda_26);
        var tmp_27 = Companion_instance_14.serializer_szze8_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_27, SerializationRegistry$lambda_27);
        var tmp_28 = Companion_instance_15.serializer_szze8_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_28, SerializationRegistry$lambda_28);
        var tmp_29 = Companion_instance_16.serializer_szze8_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_29, SerializationRegistry$lambda_29);
        var tmp_30 = Companion_instance_17.serializer_r07i7m_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_30, SerializationRegistry$lambda_30);
        var tmp_31 = Companion_getInstance_3().serializer_r07i7m_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_31, SerializationRegistry$lambda_31);
        var tmp_32 = Companion_instance_18.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_32, SerializationRegistry$lambda_32);
        var tmp_33 = Companion_getInstance_4().serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_33, SerializationRegistry$lambda_33);
        var tmp_34 = Companion_getInstance_5().serializer_nrleg8_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_34, SerializationRegistry$lambda_34);
        var tmp_35 = Companion_getInstance_6().serializer_nrleg8_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_35, SerializationRegistry$lambda_35);
        var tmp_36 = Companion_getInstance_7().serializer_nrleg8_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_36, SerializationRegistry$lambda_36);
        var tmp_37 = Companion_getInstance_8().serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_37, SerializationRegistry$lambda_37);
        var tmp_38 = Companion_getInstance_9().serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_38, SerializationRegistry$lambda_38);
        var tmp_39 = Companion_getInstance_10().serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_39, SerializationRegistry$lambda_39);
        var tmp_40 = Companion_getInstance_11().serializer_nrleg8_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_40, SerializationRegistry$lambda_40);
        var tmp_41 = Companion_instance_26.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_41, SerializationRegistry$lambda_41);
        this.register$default_82hvd6_k$(Nothing_getInstance().serializer_9w0wvi_k$());
        var tmp_42 = Companion_instance_27.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_42, SerializationRegistry$lambda_42);
        var tmp_43 = Companion_instance_28.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_43, SerializationRegistry$lambda_43);
        var tmp_44 = Companion_instance_29.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_44, SerializationRegistry$lambda_44);
        var tmp_45 = Companion_instance_30.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_45, SerializationRegistry$lambda_45);
        var tmp_46 = Companion_instance_31.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_46, SerializationRegistry$lambda_46);
        var tmp_47 = Companion_instance_32.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_47, SerializationRegistry$lambda_47);
        var tmp_48 = Companion_instance_33.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_48, SerializationRegistry$lambda_48);
        this.register$default_82hvd6_k$(Companion_instance_47.serializer_9w0wvi_k$());
        var tmp_49 = Companion_instance_34.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_49, SerializationRegistry$lambda_49);
        var tmp_50 = Companion_instance_35.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_50, SerializationRegistry$lambda_50);
        var tmp_51 = Companion_instance_36.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_51, SerializationRegistry$lambda_51);
        var tmp_52 = Companion_instance_37.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_52, SerializationRegistry$lambda_52);
        var tmp_53 = Companion_instance_38.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_53, SerializationRegistry$lambda_53);
        var tmp_54 = Companion_instance_39.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_54, SerializationRegistry$lambda_54);
        var tmp_55 = Companion_getInstance_12().serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_55, SerializationRegistry$lambda_55);
        var tmp_56 = Companion_instance_40.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_56, SerializationRegistry$lambda_56);
        var tmp_57 = Companion_instance_41.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_57, SerializationRegistry$lambda_57);
        var tmp_58 = Companion_instance_42.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_58, SerializationRegistry$lambda_58);
        var tmp_59 = Companion_instance_43.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_59, SerializationRegistry$lambda_59);
        var tmp_60 = Companion_instance_44.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_60, SerializationRegistry$lambda_60);
        var tmp_61 = Companion_getInstance_13().serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_61, SerializationRegistry$lambda_61);
        var tmp_62 = Companion_instance_45.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_62, SerializationRegistry$lambda_62);
        var tmp_63 = Companion_instance_46.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_63, SerializationRegistry$lambda_63);
        var tmp_64 = Companion_getInstance_14().serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_64, SerializationRegistry$lambda_64);
        var tmp_65 = Companion_getInstance_15().serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_65, SerializationRegistry$lambda_65);
        var tmp_66 = Companion_instance_48.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_66, SerializationRegistry$lambda_66);
        var tmp_67 = Companion_getInstance_16().serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_67, SerializationRegistry$lambda_67);
        var tmp_68 = Companion_getInstance_17().serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_68, SerializationRegistry$lambda_68);
        var tmp_69 = Companion_instance_49.serializer_hd7dek_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_69, SerializationRegistry$lambda_69);
        var tmp_70 = Companion_instance_50.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        this.register_mwrmni_k$(tmp_70, SerializationRegistry$lambda_70);
        this.register$default_82hvd6_k$(Companion_getInstance_32().serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_instance_73.serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_getInstance_33().serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_getInstance_34().serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_getInstance_35().serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_getInstance_36().serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_getInstance_37().serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_getInstance_38().serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_getInstance_39().serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_getInstance_40().serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_getInstance_41().serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(NullValue_getInstance().serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_instance_74.serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_instance_75.serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_instance_76.serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_instance_77.serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_instance_78.serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_instance_79.serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_instance_80.serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_instance_81.serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_instance_82.serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_instance_83.serializer_9w0wvi_k$());
        this.register$default_82hvd6_k$(Companion_getInstance_42().serializer_9w0wvi_k$());
      }
      register_l6joql_k$(serializer, name) {
        if (this.direct_1.containsKey_aw81wo_k$(name))
          return Unit_instance;
        // Inline function 'kotlin.collections.set' call
        this.direct_1.put_4fpzoq_k$(name, serializer);
      }
      register$default_82hvd6_k$(serializer, name, $super) {
        name = name === VOID ? serializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() : name;
        var tmp;
        if ($super === VOID) {
          this.register_l6joql_k$(serializer, name);
          tmp = Unit_instance;
        } else {
          tmp = $super.register_l6joql_k$.call(this, serializer, name);
        }
        return tmp;
      }
      register_mwrmni_k$(name, make) {
        if (this.factory_1.containsKey_aw81wo_k$(name))
          return Unit_instance;
        var tmp0 = this.factory_1;
        // Inline function 'kotlin.collections.set' call
        var value = typeof make === 'function' ? make : THROW_CCE();
        tmp0.put_4fpzoq_k$(name, value);
      }
      get_yiwm6c_k$(name, arguments_0) {
        var tmp = this.direct_1.get_wei43m_k$(name);
        var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, KSerializer()) : false) ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          var tmp1_safe_receiver = this.factory_1.get_wei43m_k$(name);
          var tmp_1 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver(arguments_0);
          tmp_0 = (!(tmp_1 == null) ? isInterface(tmp_1, KSerializer()) : false) ? tmp_1 : null;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, 'SerializationRegistry');
    SerializationRegistryClass = $;
  }
  return SerializationRegistryClass;
}
var StubPolymorphicDecoderClass;
function StubPolymorphicDecoder() {
  if (StubPolymorphicDecoderClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor() {
        StubPolymorphicDecoder_instance = null;
        super();
        StubPolymorphicDecoder_instance = this;
        this.serializersModule_1 = EmptySerializersModule();
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      decodeElementIndex_bstkhp_k$(descriptor) {
        return -1;
      }
    }
    initMetadataForObject($, 'StubPolymorphicDecoder');
    StubPolymorphicDecoderClass = $;
  }
  return StubPolymorphicDecoderClass;
}
var StubPolymorphicDecoder_instance;
function StubPolymorphicDecoder_getInstance() {
  if (StubPolymorphicDecoder_instance === VOID)
    new (StubPolymorphicDecoder())();
  return StubPolymorphicDecoder_instance;
}
//region block: exports
export {
  GenericPlaceholderException as GenericPlaceholderException172k6j5tuvnpk,
  GenericPlaceholderSerializer as GenericPlaceholderSerializer267m3qun4y50l,
  Companion_getInstance_43 as Companion_getInstance12yez9f87gqg9,
  StubPolymorphicDecoder_getInstance as StubPolymorphicDecoder_getInstance2p486kcer4bub,
};
//endregion

//# sourceMappingURL=SerializationRegistry.mjs.map
